import React from 'react'
import ReactDOM from 'react-dom'

import { polyfill } from 'mobile-drag-drop'
import { scrollBehaviourDragImageTranslateOverride } from 'mobile-drag-drop/scroll-behaviour'
import 'semantic-ui-css/semantic.min.css'
import 'mobile-drag-drop/default.css'
import App from './App'

// options are optional ;)
polyfill({
  // use this to make use of the scroll behaviour
  dragImageTranslateOverride: scrollBehaviourDragImageTranslateOverride,
})


ReactDOM.render(<App />, document.getElementById('root'))
